import React, { useState, useEffect } from 'react';
import { onlyText } from 'react-children-utilities';
import copy from 'copy-to-clipboard';
import { getAnchor } from '~/helpers/anchor';

const AnchorIcon = ({ anchor }) => {
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (showSuccess) {
      const timeout = setTimeout(() => setShowSuccess(false), 2000);
      return () => {
        clearTimeout(timeout);
      };
    }

    return undefined;
  }, [showSuccess]);

  const onClick = () => {
    setShowSuccess(true);
    copy(`${window.location.origin}${window.location.pathname}'#${anchor}`);
  };

  return (
    <div className="ico-container">
      {!showSuccess && (
        <a
          aria-label="Copy"
          className="icon icon-copy-url"
          onClick={onClick}
          href={`#${anchor}`}
        />
      )}
      {showSuccess && (
        <svg
          width="28px"
          height="100%"
          viewBox="0 0 32 32"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xmlSpace="preserve"
          style={{ fillRule: 'evenodd', clipRule: 'evenodd' }}
          className="checkmark-success"
        >
          <g id="_002">
            <circle
              id="Oval-Copy-5"
              cx="16"
              cy="16"
              r="15.5"
              className="checkmark-circle"
              style={{ fill: 'none', stroke: 'rgb(0,206,21)', strokeWidth: '1px' }}
            />
            <path
              d="M22.026,12.01L13.509,20.508L9.993,16.992"
              className="check"
              style={{
                fill: 'none',
                stroke: 'rgb(0,206,21)',
                strokeWidth: '2px',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeMiterlimit: 1.5
              }}
            />
          </g>
        </svg>
      )}
    </div>
  );
};

const h = (children, level) => {
  const text = onlyText(children);
  const anchor = getAnchor(text);

  if (level === 1) {
    return <h1>{text}</h1>;
  }

  const Header = `h${level}`;
  return (
    <Header id={anchor}>
      {text}
      <AnchorIcon anchor={anchor} />
    </Header>
  );
};

export default h;
